<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="hotelDailyCostWithExceptionsObj.isActive ? 'tag is-success' : 'tag'
        ">Standard rule</span>
      <div class="right-content">
        <div class="lefttext">
          <!-- <p class="paragrapgh">Average daily cost for exceptions cities</p> -->
          <!-- <p>Trigger when the daily cost for exceptions cities is more than  <u> -->
          <p class="paragrapgh">{{ title }}</p>
          <p>
            Trigger when the daily cost is more than

            <span class="rule-config-variable" @click="isEdit = !isEdit">
              {{
                hotelDailyCostWithExceptionsObj.value.dailyCost
                  ? "$" + hotelDailyCostWithExceptionsObj.value.dailyCost
                  : "N/A"
              }}
              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>

          <p>
            Hotel average nightly cost for exceptions cities is more than
            <span class="rule-config-variable" @click="isEdit = !isEdit">
              {{
                hotelDailyCostWithExceptionsObj.value.exceptionCitiesDailyCost
                  ? "$" +
                  hotelDailyCostWithExceptionsObj.value
                    .exceptionCitiesDailyCost
                  : "N/A"
              }}
              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>
          <p v-if="hotelDailyCostWithExceptionsObj.value.exceptionCities != ''">
            Exception cities:
            <span class="rule-config-variable" @click="isEdit = !isEdit">
              {{ hotelDailyCostWithExceptionsObj.value.exceptionCities.map(city => city.value).join(', ') }}
              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>
        </div>
        <div class="allbtns">
    
          <b-switch :rounded="true" :value="hotelDailyCostWithExceptionsObj.isActive"
            v-model="hotelDailyCostWithExceptionsObj.isActive" @input="hotelDailyCostWithExceptions"
            :left-label="true">{{ hotelDailyCostWithExceptionsObj.isActive ? 'Active' : 'Inactive' }}
          </b-switch>
        </div>
      </div>
    </div>
    <div v-if="isEdit" class="edittravelpolicy editTravel2">
      <HotelDailyCostWithExceptionCities @hotelDailyCostForExceptionCities="getValue"
        :hotelExceptionCities="propsData" />
      <p>Enter amount and select exception cities</p>
      <b-button @click="saveCall">SAVE</b-button>
    </div>
    <StandardRuleActions v-if="hotelDailyCostWithExceptionsObj.isActive && !isEdit"
      :ruleObj="hotelDailyCostWithExceptionsObj" :title="title" @save="updateActions" />
  </div>
</template>
<script>
import HotelDailyCostWithExceptionCities from "../CommonRules/HotelDailyCostWithExceptionCities.vue";
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
  name: "HotelDailyCostExceptionCities",
  props: {
    value: {
      type: [Object],
    },
  },
  components: {
    HotelDailyCostWithExceptionCities,
    StandardRuleActions
  },
  data() {
    return {
      propsData: {
        dailyCost: null,
        exceptionCities: [],
        exceptionCitiesDailyCost: null,
      },
      hotelDailyCostWithExceptionsObj: this.value
        ? this.value
        : {
          name: "hotelDailyCostWithExceptions",
          isActive: false,
          type: "hotel",
          message: "",
          value: {
            dailyCost: 200,
            exceptionCitiesDailyCost: 350,
            exceptionCities: [],
          },
        },
      isEdit: false,
      emitedValue: null,
      isTrue: null,
      title: "Average daily cost"
    };
  },
  methods: {
    saveCall() {
      this.isEdit = false;
      if (this.emitedValue || this.emitedValue == "") {
        console.log(this.emitedValue);
        this.hotelDailyCostWithExceptionsObj.value = this.emitedValue;

        /********* graving prop data  *********/
        this.propsData["dailyCost"] = this.emitedValue.dailyCost;
        this.propsData["exceptionCities"] = this.emitedValue.exceptionCities;
        this.propsData[
          "exceptionCitiesDailyCost"
        ] = this.emitedValue.exceptionCitiesDailyCost;


        this.buildMessage();
      }
    },
    getValue(val) {
      this.emitedValue = val;
      this.isTrue = val.isSetExceptionCities;

    },
    hotelDailyCostWithExceptions() {
      if (!this.hotelDailyCostWithExceptionsObj.isActive) {
        // Clear the custom action parameters when deactivating
        this.clearActionParams();
      } else {
        // Rebuild message when activating
        this.buildMessage();
      }

      this.emitRuleObj();
    },
    buildMessage() {
      var string = "Trigger when the hotel daily cost is more than ";

      string += (this.hotelDailyCostWithExceptionsObj.value.dailyCost
        ? "$" + this.hotelDailyCostWithExceptionsObj.value.dailyCost
        : "N/A")

      if (this.hotelDailyCostWithExceptionsObj.value.exceptionCities) {
        string += ". For exception cities (" + this.hotelDailyCostWithExceptionsObj.value.exceptionCities.map(city => city.value).join(', ') + '), trigger when the daily cost is more than ';

        string += (this.hotelDailyCostWithExceptionsObj.value.exceptionCitiesDailyCost
          ? "$" + this.hotelDailyCostWithExceptionsObj.value.exceptionCitiesDailyCost
          : "N/A")
      }

      this.hotelDailyCostWithExceptionsObj.message = string;
    },
    emitRuleObj() {

      this.$emit("hotelDailyCostWithExceptions",this.hotelDailyCostWithExceptionsObj);
    },
    clearActionParams() {
      // Reset to default actions when rule is not active ()
      this.hotelDailyCostWithExceptionsObj.useCustomActions = false;
      delete this.hotelDailyCostWithExceptionsObj.visibility;
      delete this.hotelDailyCostWithExceptionsObj.approvalLevel;
      delete this.hotelDailyCostWithExceptionsObj.notifications;
    },
    updateActions(updatedRule) {
      // Merge the updated properties into hotelDailyCostWithExceptionsObj
      this.hotelDailyCostWithExceptionsObj = { ...this.hotelDailyCostWithExceptionsObj, ...updatedRule };

      // If useCustomActions is false, delete the associated properties
      if (!updatedRule.useCustomActions) {
        this.clearActionParams();
      }

      this.buildMessage();

      this.emitRuleObj();
    },
  },
  mounted() {
    this.hotelDailyCostWithExceptionsObj.type = "hotel";

    this.propsData.dailyCost = this.hotelDailyCostWithExceptionsObj.value.dailyCost;
    this.propsData.exceptionCitiesDailyCost = this.hotelDailyCostWithExceptionsObj.value.exceptionCitiesDailyCost;
    this.propsData.exceptionCities = this.hotelDailyCostWithExceptionsObj.value.exceptionCities;

    this.emitRuleObj();
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.hotelDailyCostWithExceptionsObj = this.value;
        this.hotelDailyCostWithExceptionsObj.type = "hotel";
        this.buildMessage();
        this.emitRuleObj();
      },
      deep: true,
    },
  },
};
</script>
